import us from './enUS.js'

const currentYear = new Date().getUTCFullYear()

export default {
  ...us,
  Header: {
    ...us.Header,
    countryPostfix: 'in India',
    titleFormat: (count: number, category: string) => `${count} Best ${category} ${currentYear} in India`,
    titleMagaTop: (count: number, category: string) => `Top-${count} ${category}`,
    titleMagaLoved: 'Loved in India',
  },
  ProductCard: {
    ...us.ProductCard,
    ctaText: (trafficType?: string, _partnerName?: string) => {
      switch (trafficType) {
        case 'organic-amazon-only':
          return 'More Info'
        case 'paid-long-tail':
          return 'More Info'
        case 'organic-buying-options':
          return 'View Product'
        case 'dws':
          return 'View Deal'
        default:
          return 'View Product'
      }
    },
  },
  Badge: {
    ...us.Badge,
    countryFavorite: "India's Favorite",
    countryPick: "India's Pick",
    countryTopRated: 'Top Rated in India',
  },
  ShippingSection: {
    title: "Shipping from Amazon's IN regional warehouses",
  },
} as typeof us
